import {useSnapshot} from 'valtio'
import {store} from '@/form.js'
import {Layout} from '@/layouts/Layout.jsx'
import {CardFlow} from '@/pages/CardFlow/CardFlow.jsx'
import {FatalErrorPage} from '@/pages/FatalErrorPage/FatalErrorPage.jsx'

function App() {
  const appState = useSnapshot(store.appSlice.state)

  return (
    <Layout>
      {appState.fatalError ? <FatalErrorPage/> : <CardFlow/>}
    </Layout>
  )
}

export default App
